import { useEffect, useMemo, useState } from "react";

/**
 * @todo expand to track x and y scroll, move to common-ui. first use of this
 * is for the vertical alignment doc so we can sync scroll positions of two
 * independent divs. */
export const usePageScroll = () => {
  const [scrollPositionX, setScrollPositionX] = useState(0);
  const [scrollPositionY, setScrollPositionY] = useState(0);

  useEffect(() => {
    const monitorScroll = () => {
      setScrollPositionX(window.scrollX);
      setScrollPositionY(window.scrollY);
    };

    document.addEventListener("scroll", monitorScroll);
    return () => document.removeEventListener("scroll", monitorScroll);
  }, []);

  return useMemo(
    () => ({ x: scrollPositionX, y: scrollPositionY }),
    [scrollPositionX, scrollPositionY],
  );
};
